import React, {useEffect, useRef, useState, useCallback} from 'react';
import {getStepFromPosition} from './getStepFromPosition.js';

export const useRowSelection = ({
    scrollContainer,
    id,
    sequencerEngine,
    xScale,
    resolution,
    setArrangementRowSelections
}) => {
    const resizingSelection = useRef(false);

    const scrollLeft = () => scrollContainer.current.scrollLeft;

    const onRowSelectionDown = useCallback((e) => {
        let step = getStepFromPosition(e.pageX + scrollLeft(), resolution, undefined, xScale);
        resizingSelection.current = true;
        let rowSelections = {};
        rowSelections[id] = {
            start: step,
            end: step
        };
        setArrangementRowSelections(rowSelections);
 
    }, [resolution, xScale, id]);

    const onRowSelectionUp = useCallback((e) => {
        resizingSelection.current = false;
    }, []);

    const getState = () => sequencerEngine.state;
    
    const onRowSelectionMove = useCallback((e) => {
        let step = getStepFromPosition(e.pageX + scrollLeft(), resolution, undefined, xScale);
        let _resolution = 32 / resolution.resolution;
        let remainder = step % _resolution;
        step -= remainder;
 
        if (resizingSelection.current) {
            let selection = getState().arrangement.rowSelections[id];
            if (selection !== undefined) {
                selection.end = step;
                let selections = {};
                selections[id] = selection;
                setArrangementRowSelections(selections);
            }
        }
    }, [xScale, id, resolution]);

    return {
        onRowSelectionMove,
        onRowSelectionUp,
        onRowSelectionDown
    }
};
